export function isPhone(vuetify) {
  return !vuetify.breakpoint.smAndUp
}
